import Skeleton from 'react-loading-skeleton';
import { styled } from 'goober';

import { colors } from '@/theme/colors';
import { Flexbox } from '@/ui/flexbox/flexbox';
import { Inline } from '@/ui/line/line';
import { Stack } from '@/ui/line/line';

export const NotificationCardSkeleton = () => {
  return (
    <Container justify="space-between" alignItems="center">
      <Inline gap="12px" alignItems="center">
        <Skeleton circle width={30} height={30} />
        <SkeletonTextContainer>
          <Skeleton height={14} width={200} />
          <Skeleton height={12} width={150} style={{ marginTop: '4px' }} />
        </SkeletonTextContainer>
      </Inline>
      <Skeleton height={12} width={60} />
    </Container>
  );
};

const Container = styled(Flexbox)`
  border-radius: 10px;
  border: 1px ${colors.gray.c3} solid;
  padding: 16px;
  background-color: ${({ theme }) => theme.colors.basics.white};
`;

const SkeletonTextContainer = styled(Stack)`
  gap: 4px;
`;
